const ArrowUp = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 3.5L3.75 9.75L4.64375 10.6437L9.375 5.90625V16.5H10.625V5.90625L15.3563 10.6437L16.25 9.75L10 3.5Z" />
  </svg>
);

export default ArrowUp;
